const buildType = import.meta.env.VITE_BUILD_TYPE

export const getContainerId = () => {
    if (buildType === "inline quiz") return "tangent-main-container";
    if (buildType === "popup quiz") return "tangent-popup-quiz";
}

export const isInlineQuiz = () => {
    return buildType === "inline quiz";
}